import { useNavigate } from 'react-router-dom';

import { UserAvatar, CloseButton, Heading, Paragraph } from '@app/shared/ui/atoms/Common';
import { Gender } from '@app/shared/types/common';
import { Page } from '@app/routes';

interface TopSectionProps {
  channelIdx: number;
  userAvatar?: string | null;
  userGender?: Gender | null;
  title: string;
  description: string;
  tags: string;
}

export function TopSection({
  channelIdx,
  userAvatar,
  userGender,
  title,
  description,
  tags,
}: TopSectionProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col">
      <CloseButton className="ml-auto" onClick={() => navigate(Page.STONE_ABILITIES)} />

      <div className="relative mt-3 flex items-center gap-6">
        <UserAvatar avatar={userAvatar} gender={userGender} className="size-[132px]" />
        <span className="absolute left-[90px] top-0 flex h-[50px] w-[50px] items-center justify-center rounded-full bg-[#8D43A4] text-[26px] font-bold text-foreground">
          {channelIdx}
        </span>
        <div className="flex flex-col gap-0.5">
          <Heading level={5}>{title}</Heading>
          <Paragraph size="sm" className="font-normal leading-tight text-gray-neutral">
            {description}
          </Paragraph>
        </div>
      </div>

      <Paragraph
        variant="white"
        className="mt-6 flex items-center text-center justify-center rounded-full bg-[#8D43A4] p-2 uppercase"
      >
        {tags}
      </Paragraph>
    </div>
  );
}
